import { render, staticRenderFns } from "./PopWin.vue?vue&type=template&id=be013526&scoped=true&"
import script from "./PopWin.vue?vue&type=script&lang=js&"
export * from "./PopWin.vue?vue&type=script&lang=js&"
import style0 from "./PopWin.vue?vue&type=style&index=0&id=be013526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be013526",
  null
  
)

export default component.exports